<template>
  <div class="login-form">
    <el-row type="flex" justify="center">
      <h1 class="title">蘭陽地區林業文化歷史資料庫 - 重設密碼</h1>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-input v-model="email" placeholder="請輸入電子郵件"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-input v-model="new_password" type="password" placeholder="請輸入新密碼"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-input v-model="confirm_password" type="password" placeholder="請再次輸入新密碼"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-button class="login-btn" @click="resetPwd">修改密碼</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//import { mapActions, mapGetters } from 'vuex'
import api from '@/api/index.js'
import { Message } from 'element-ui';


export default {
  data () {
    return {
      email: '',
      new_password: '',
      confirm_password: '',
}
  },
  mounted () {
    if(this.$route.query && typeof this.$route.query.acc !== 'undefined') {
      this.email = this.$route.query.acc
    }
  },
  methods: {
    async resetPwd () {
      console.log('reset button clicked')

      if(this.email === '' ){
        Message.warning('請輸入電子郵件')
      }else if(this.new_password === '' ){
        Message.warning('請輸入新密碼')
      }else if(this.confirm_password === '' ){
        Message.warning('請再次輸入新密碼')
      }else {
        let res = await api.reset_pwd(
          {
            email: this.email, 
            new_password: this.new_password, 
            confirm_password: this.confirm_password
        })
        if (res.success) {
          this.backstage_router_push({
            path: `/login`,
            query: {}
          })
          Message.success(res.message)
        }
        else {
          Message.warning(res.message)
        }
      }

      
    },
  }
}
</script>

<style lang="scss" scoped>
  .login-form {
    height: 100vh;
    width: 100vw;
    background-color:#196f3d;  
  }
  .el-row {
    margin-bottom: 40px;
    &:first-child {
      margin-top: 150px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .title {
    color: white;
    font-size: 4em;
  }
  .login-btn {
    width: 100%;
  }

  /deep/.el-button,
  /deep/.el-button:visited,
  /deep/.el-button:focus,
  /deep/.el-button:active {
    background-color: grey;
    border-color: grey;
    color: white;
  }

  /deep/.el-button:hover {
      color: white;
      border-color: rgba(#196f3d, 1);
      background-color: rgba(#191919, 0.1);
  }

</style>
